import { render, staticRenderFns } from "./Brief.vue?vue&type=template&id=a4cd628a&scoped=true&"
import script from "./Brief.vue?vue&type=script&lang=js&"
export * from "./Brief.vue?vue&type=script&lang=js&"
import style0 from "./Brief.vue?vue&type=style&index=0&id=a4cd628a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cd628a",
  null
  
)

export default component.exports